import { telephone, message } from "@simplybusiness/icons";
import { type DOMProps, Flex, Icon, Link, Text } from "@simplybusiness/mobius";
import { QuoteReference } from "./QuoteReference";
import type React from "react";
import type { RefAttributes } from "react";
import type { WithMetadata } from "../../pages";
import { ChatBox } from "../shared/ChatBox";

export type QuoteHelpElement = HTMLDivElement;

export interface QuoteHelpProps
  extends DOMProps, RefAttributes<QuoteHelpElement> {
  contactPhoneNumber: string;
  referenceNumbers: string[];
  chatWithAgent: boolean;
  /** Custom class name for setting specific CSS */
  className?: string;
  elementType?: React.ElementType;
}

export const QuoteHelp = ({ ref, ...props }: WithMetadata<QuoteHelpProps>) => {
  const { contactPhoneNumber, referenceNumbers, chatWithAgent, ...otherProps } =
    props;

  return (
    <ChatBox ref={ref} {...otherProps}>
      <Text variant="body">
        Have a question about your quote? Give us a call &mdash; we&rsquo;re
        here to help.
      </Text>
      {(contactPhoneNumber || chatWithAgent) && (
        <Flex className="mobius-quote-help__contact-container">
          {contactPhoneNumber && (
            <Link
              href={`tel:${contactPhoneNumber}`}
              className="mobius-quote-help__contact-phone-number"
            >
              <Icon fixedWidth icon={telephone} /> {contactPhoneNumber}
            </Link>
          )}
          {chatWithAgent && <ChatBox.ChatLink icon={message} />}
        </Flex>
      )}
      <QuoteReference referenceNumbers={referenceNumbers} />
    </ChatBox>
  );
};

QuoteHelp.displayName = "QuoteHelp";
